import { isNull } from 'lodash/fp';
import React, { useCallback, useMemo } from 'react';

import { useAppDispatch, useAppSelector } from '../../../hooks/react-redux';
import { ConfirmationModal } from '../../shared/modal/ConfirmationModal';
import { downloadPortfolioAnalyticsStarted, getDownloadFilename, setFilename, toggleDownloadModal } from './store';
import { Text } from '../../shared/text/Text';
import styles from './PortfolioAnalytics.module.scss';
import { ModalHeader } from '../../shared/modal/ModalHeader';
import { SaveFile } from '../../shared/icons';

export const PortfolioAnalyticsDownloadModal: React.FC = () => {
    const dispatch = useAppDispatch();
    const filename = useAppSelector(getDownloadFilename);
    const isOpen = useMemo(() => !isNull(filename), [filename]);
    const closeModal = () => dispatch(toggleDownloadModal(null));
    const updateFilename = useCallback((value: string) => dispatch(setFilename(value)), [dispatch]);
    const confirm = useCallback(() => dispatch(downloadPortfolioAnalyticsStarted()), [dispatch]);
    const confirmDisabled = useMemo(() => isNull(filename) || filename === '', [filename]);

    return (
        <ConfirmationModal
            isOpen={isOpen}
            closeModal={closeModal}
            confirm={confirm}
            confirmDisabled={confirmDisabled}
            closeOnOverlayClick={false}
            spaceBetweenButtons
        >
            <div className={styles.downloadModal}>
                <ModalHeader
                    label='Please create a filename for the excel download'
                    testId='portfolio-analytics-download-modal'
                    marginBottom='0px'
                    icon={SaveFile}
                />
                <div className={styles.filenameInput}>
                    <Text
                        onChange={e => updateFilename(e.currentTarget.value)}
                        value={filename || ''}
                        testId='portfolio-analytics-download'
                        placeholder='File Name...'
                        marginBottom='0px'
                    />
                </div>
            </div>
        </ ConfirmationModal>
    );
};
